exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".modal-dialog[data-v-e26bb6c4]{max-width:1200px!important;margin:1.75rem auto}.modal-content[data-v-e26bb6c4]{max-height:100%}.modal-content .modal-body[data-v-e26bb6c4]{max-height:100%;min-height:100%;overflow:auto}.modal-content .modal-body .content[data-v-e26bb6c4]{min-height:100%;overflow-y:auto}.modal-content .modal-body .content .obsolete[data-v-e26bb6c4]{text-decoration:line-through}.modal-content .modal-body .input-group-prepend .input-group-text[data-v-e26bb6c4]{display:block}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-e26bb6c4","scoped":true,"hasInlineConfig":false}!./node_modules/sass-loader/lib/loader.js!./node_modules/sass-resources-loader/lib/loader.js?{"resources":["./scss/epoq/_wp_variables.scss","./node_modules/bootstrap/scss/_mixins.scss"]}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/custom/epoq/dialogs/modalVariant.vue
// module id = 1385
// module chunks = 186